
import React from 'react';

import Down00 from './svgs/Down00.svg';
import Down01 from './svgs/Down01.svg';
import Down10 from './svgs/Down10.svg';
import Down19 from './svgs/Down19.svg';

import * as styles from './styles.module.scss';

const Component = (src: typeof Down00) => function Graphic() {
	return (
		<>
			<div className={styles.heading}>Impact</div>
			<img
				className={styles.graphic}
				src={src as string}
			/>
		</>
	);
};

export default {
	Down00: Component(Down00),
	Down01: Component(Down01),
	Down10: Component(Down10),
	Down19: Component(Down19),
};
